

import { Button, Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody, ModalCloseButton, Text } from "@chakra-ui/react";
import useMobile from "../../hooks/useMobile";
import { useEffect, useState } from "react";
import CustomTextarea from "../input/CustomTextarea";






const TextareaEditModal = ({ isOpen, title, label, onClose, onSave , initialValue, isLoading}: {
    title:string;
    label:string;
    isOpen: boolean;
    onClose: () => void;
    onSave:(v:string) => void;
    isLoading : boolean;
    initialValue : string;
}) => {
    const isMobile = useMobile(600)
    const [value,setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    },[initialValue])  



    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody p='0'>
                    <Text variant='title' fontSize='2xl' fontWeight='500' mb='20px'>
                        {title}
                    </Text>

                    <Text variant='title' fontSize={isMobile ? 'md' : 'lg'} lineHeight='19px' mt='25px' mb='10px'>
                        {label}
                    </Text>
                    <CustomTextarea
                        value={value}
                        onChange={v => setValue(v)}
                        placeholder='Some details about the event...'
                    />
                </ModalBody>
                <ModalFooter>
                    <Button variant="heavy" size='sm' isLoading={isLoading}
                        onClick={() => onSave(value)}
                    >Save</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}


export default TextareaEditModal